import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Box,
  Paper,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { FaEye, FaEyeSlash, FaLock } from "react-icons/fa";
import BackgroundImage from "../images/map4.jpg";
import Footer from "./Footer";

const getApiBaseUrl = () => {
  const protocol = window.location.protocol === "https:" ? "https" : "http";
  const baseUrl = process.env.REACT_APP_URL.replace(/^https?:\/\//, "");
  return `${protocol}://${baseUrl}`;
};

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleResetPassword = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(`${getApiBaseUrl()}/reset`, {
        email,
        username,
        newPassword,
      });
      alert(response.data.msg);
      navigate("/login");
    } catch (err) {
      alert(err.response?.data?.msg || "Terjadi kesalahan saat reset password.");
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          height: "auto",
          backgroundImage: `url(${BackgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: "fixed",
          padding: isMobile ? 2 : 4,
        }}
      >
        <Paper
          elevation={6}
          sx={{
            p: isMobile ? 3 : 4,
            width: "100%",
            maxWidth: 380,
            textAlign: "center",
            borderRadius: 3,
            bgcolor: "rgba(255, 255, 255, 0.95)",
            margin: "auto",
          }}
        >
          {/* Logo */}
          <img
            src="/images/logobaru.png"
            alt="Logo Aplikasi"
            style={{ 
              width: isMobile ? "60px" : "80px", 
              marginBottom: isMobile ? "8px" : "10px" 
            }}
          />
          <Typography 
            variant={isMobile ? "subtitle1" : "h6"} 
            gutterBottom
            sx={{ fontSize: isMobile ? "0.9rem" : "1.25rem" }}
          >
            Sistem Informasi Digital Layanan dan Manajemen Perumahan
          </Typography>

          <Typography 
            variant="body2" 
            gutterBottom 
            sx={{ 
              mb: 2, 
              fontSize: isMobile ? "0.8rem" : "0.875rem",
              color: "text.secondary"
            }}
          >
            Masukkan email dan username Anda untuk reset password
          </Typography>

          {/* Form */}
          <form onSubmit={handleResetPassword}>
            <TextField
              fullWidth
              label="Email"
              margin="normal"
              variant="filled"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              size={isMobile ? "small" : "medium"}
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "white",
                  borderRadius: "8px",
                },
                "& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after": {
                  display: "none",
                },
                "& .MuiInputLabel-root": {
                  fontSize: isMobile ? "0.8rem" : "1rem",
                },
                mt: isMobile ? 1 : 2,
              }}
            />

            <TextField
              fullWidth
              label="Username"
              margin="normal"
              variant="filled"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              size={isMobile ? "small" : "medium"}
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "white",
                  borderRadius: "8px",
                },
                "& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after": {
                  display: "none",
                },
                "& .MuiInputLabel-root": {
                  fontSize: isMobile ? "0.8rem" : "1rem",
                },
                mt: isMobile ? 1 : 2,
              }}
            />

            <TextField
              fullWidth
              label="Password Baru"
              type={showPassword ? "text" : "password"}
              margin="normal"
              variant="filled"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              size={isMobile ? "small" : "medium"}
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "white",
                  borderRadius: "8px",
                },
                "& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after": {
                  display: "none",
                },
                "& .MuiInputLabel-root": {
                  fontSize: isMobile ? "0.8rem" : "1rem",
                },
                mt: isMobile ? 1 : 2,
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      size="small"
                    >
                      {showPassword ? <FaEyeSlash size={isMobile ? 16 : 18} /> : <FaEye size={isMobile ? 16 : 18} />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {/* Tombol Reset Password */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              size={isMobile ? "medium" : "large"}
              sx={{
                mt: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
                py: isMobile ? 1 : 1.5,
              }}
            >
              <FaLock size={isMobile ? 12 : 14} /> Reset Password
            </Button>
          </form>

          {/* Tombol Kembali ke Login */}
          <Button
            fullWidth
            variant="text"
            color="primary"
            onClick={() => navigate("/login")}
            size={isMobile ? "small" : "medium"}
            sx={{ 
              mt: 1, 
              textTransform: "none",
              fontSize: isMobile ? "0.75rem" : "0.875rem"
            }}
          >
            Kembali ke Login
          </Button>
        </Paper>
      </Box>
      <Footer />
    </>
  );
};

export default ResetPassword;